import type { Task } from "./types";
import { getLatestTask } from "./taskStatus";

export function getWorkspaceStartFailureMessageFromTasks(
  tasks: Task[],
): string {
  const latest = getLatestTask("start-environment-instance", tasks);
  if (latest?.status !== "failed") return "";

  switch (latest.labels?.publicErrorCode) {
    case "CAPACITY_UNAVAILABLE":
      return "Capacity is unavailable in this region. Try another region or instance type.";
    case "QUOTA_EXCEEDED":
      return "Cloud quota is exhausted. Check your cloud account quota or contact its administrator.";
    default:
      return "The environment could not start. Please try again or contact support.";
  }
}
